/* eslint-disable max-len */
import { FiInstagram, FiYoutube } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import { IoLogoLinkedin } from 'react-icons/io5';
import { Link } from 'react-router';
import { PhoneNumber, PrivacyPolicyURL, TermsOfServiceURL } from '../../function';

function MainFooter() {
  const socialLinks = [
    { href: 'https://www.instagram.com/un.desk/', label: 'Nosso Instagram', icon: FiInstagram },
    { href: `https://wa.me/${PhoneNumber}`, label: 'Nosso WhatsApp', icon: FaWhatsapp },
    { href: 'https://www.youtube.com/@Un-Desk', label: 'Nosso Canal no YouTube', icon: FiYoutube },
    { href: 'https://www.linkedin.com/company/un-desk', label: 'Nosso Linkedin', icon: IoLogoLinkedin },
  ];

  return (
    <footer className="bg-slate-900 text-white pb-8 px-8">
      <div className="max-w-7xl mx-auto">

        <footer className=" border-t-2 border-slate-800 pt-8">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-col items-center gap-8 md:flex-row md:justify-between">

            <div className="flex gap-4 text-sm">
              <Link to={PrivacyPolicyURL} target="_blank" className="">
                Política de Privacidade
              </Link>
              <span className="text-slate-600">|</span>
              <Link to={TermsOfServiceURL} target="_blank" className="">
                Termos de Uso
              </Link>
            </div>

            <p className="text-white text-sm text-center">
              Copyright ©
              {' '}
              {new Date().getFullYear()}
              {' '}
              UnMEP. Todos os direitos reservados.
            </p>

            <div className="flex items-center gap-6">
              {socialLinks.map((link) => {
                const Icon = link.icon;
                return (
                  <a
                    key={link.label}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={link.label}
                    className="text-white"
                  >
                    <Icon size={20} />
                  </a>
                );
              })}
            </div>

          </div>
        </footer>
      </div>
    </footer>
  );
}

export default MainFooter;
